import type { UseFormReturn } from 'react-hook-form';

import type { ActionPermissionType, AppRolePermissionForm } from '../../types';

export function updateCheckboxIfDefined(
  formContext: UseFormReturn<AppRolePermissionForm>,
  category: string,
  name: string,
  action: ActionPermissionType,
  value: boolean,
) {
  if (formContext.getValues(`${category}.${name}.${action}`) !== undefined) {
    formContext.setValue(`${category}.${name}.${action}`, value);
  }
}
